import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { CommonModule } from '@angular/common';
import { SidenavComponent } from './Components/Layouts/sidnav/sidnav.component';
import { SharedService } from './Services/shared.service';
import { HeaderComponent } from './Components/Layouts/header/header.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, SidenavComponent, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  title = 'CDM';
  sidenavOpen: boolean = true; // Initial state of sidenav
  showHeaderAndSidenav = true;
  loginData: any;
  constructor(
    private router: Router,
    private sharedService: SharedService
  ) {
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        ) // Type guard for NavigationEnd
      )
      .subscribe((event: NavigationEnd) => {
        if (
          event.urlAfterRedirects.includes('/login') ||
          event.urlAfterRedirects.includes('/account-deletion') ||
          event.urlAfterRedirects.includes('/privacy-policy') ||
          event.urlAfterRedirects.includes('/page-not-found')
        ) {
          this.showHeaderAndSidenav = false;
        } else {
          this.showHeaderAndSidenav = true;
        }
      });
  }

  ngOnInit(): void {
  
  }

  toggleSidenav() {
    this.sidenavOpen = !this.sidenavOpen;
  }
}
